import * as React from 'react';

import { Button, Menu } from '@rematter/ui-web';
import { LucideMoreHorizontal } from 'lucide-react';

import { QuoteRecord } from '../../types/quote';

import { useQuoteDetailMenuItems } from './hooks/useQuoteDetailMenuItems';

export type QuoteActionMenuProps = {
  quote: QuoteRecord;
  onVoid?: (quote: QuoteRecord) => void;
};

//
// ⚛️ ⚛️ ⚛️ QUOTE ACTION MENU ⚛️ ⚛️ ⚛️
//
export const QuoteActionMenu: React.FC<QuoteActionMenuProps> = ({
  quote,
  onVoid,
}) => {
  // Callbacks
  const handleVoid = React.useCallback(() => {
    onVoid?.(quote);
  }, [quote, onVoid]);

  // Other data hooks
  const menuItems = useQuoteDetailMenuItems({
    quote,
    onVoid: onVoid ? handleVoid : undefined,
  });

  if (menuItems.length === 0) return null;

  return (
    <div className="@QuoteActionMenu flex justify-center">
      <Menu
        trigger={
          <Button
            size="icon"
            icon={<LucideMoreHorizontal className="size-4" />}
            variant="outline"
          />
        }
        items={menuItems}
      />
    </div>
  );
};
